import React from 'react';

import { Global, css } from '@emotion/react';

const GlobalCSS = () => (
  <Global
    styles={css({
      'html, body, input, textarea, button': {
        fontFamily: 'Graphik, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif',
      },
      'html, body': {
        margin: 0,
        padding: 0,
      },
      'ul, ol': {
        padding: 0,
        marginLeft: '20px',
      },
      '*, *::before, *::after': {
        boxSizing: 'border-box',
      },
      img: {
        maxWidth: '100%',
      },
      fieldset: {
        border: 'none',
      },
      '.osano-cm-widget': {
        display: 'none',
      },
    })}
  />
);

export default GlobalCSS;
